import { render, staticRenderFns } from "./onlineBanner.vue?vue&type=template&id=242fdcda&scoped=true&"
import script from "./onlineBanner.vue?vue&type=script&lang=js&"
export * from "./onlineBanner.vue?vue&type=script&lang=js&"
import style0 from "./onlineBanner.vue?vue&type=style&index=0&id=242fdcda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242fdcda",
  null
  
)

export default component.exports